export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none">
            <path
                d="M30.6318 23.3415L20.9411 33.0322C20.243 33.7303 19.1112 33.7303 18.4131 33.0322L6.61573 21.2348C3.59067 18.2098 3.59067 13.3052 6.61573 10.2801C9.64078 7.25509 14.5454 7.25509 17.5704 10.2801L19.6671 12.3768"
                stroke="white"
                strokeWidth="2"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M32.7555 10.4264C35.6999 13.3707 35.7474 18.115 32.898 21.1174L32.6968 21.3217L30.6313 23.3432L25.7843 18.4961C25.5523 18.2641 25.1763 18.2633 24.9433 18.4944L22.7101 20.7098C21.2424 22.1659 18.8736 22.1611 17.4117 20.6992L17.2116 20.4992C15.6896 18.9772 15.6542 16.5316 17.1054 14.9666L17.2342 14.8339L21.7573 10.3825C24.8135 7.37468 29.7234 7.39428 32.7555 10.4264Z"
                stroke="white"
                strokeWidth="2"
            />
            <path
                d="M14.2417 12.8494C12.8455 11.4532 10.5819 11.4532 9.18567 12.8494C7.78949 14.2456 7.78949 16.5092 9.18567 17.9054"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    );
}
